import React from 'react'
import algoliasearch from 'algoliasearch/lite'
import { useSelector, useDispatch } from 'react-redux'
import { InstantSearch, Configure } from 'react-instantsearch-dom'

import ButtonClose from '~/components/core/buttonClose'

import trads from '~/intl/trads.json'

import CustomSearchBox from '~/components/features/labo/searchbox'
import ResultsLabo from '~/components/features/labo/resultsLabo'
import ResultsOther from '~/components/features/labo/resultsOther'

import scrollManager from '~/utils/scrollManager'
import { setHasLaboOpen } from '~/store/actions'

const Labo = React.memo(
  ({ isOpen }) => {
    const dispatch = useDispatch()
    const lang = useSelector((state) => state.lang)
    const searchClient = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_API_KEY,
    )

    return (
      <>
        {isOpen && (
          <div className={`labo ${isOpen && 'is-open'}`}>
            <InstantSearch
              searchClient={searchClient}
              indexName={process.env.GATSBY_ALGOLIA_INDEX}
            >
              <Configure
                filters={`node_locale:${lang} AND canBeDisplayed=1`}
                hitsPerPage="1000"
              />

              <div className="labo__top bg-purple">
                <ButtonClose
                  action={() => {
                    dispatch(setHasLaboOpen(false))
                    scrollManager.restart()
                  }}
                  color="white"
                  className="labo__close"
                />

                <div className="fluid-grid">
                  <div className="col-12 lg-col-10 xl-col-8 mx-auto">
                    <div className="labo__intro mb-10">
                      <h2 className="title-cut title-cut--purple title-cut--labo  text-purple text-center md:text-left">
                        {trads[lang].search.title}
                      </h2>

                      <div className="mt-6">
                        <CustomSearchBox />
                      </div>
                    </div>

                    <ResultsLabo />
                  </div>
                </div>
              </div>

              <ResultsOther />
            </InstantSearch>
          </div>
        )}
      </>
    )
  },
  (prevProps, nextProps) => prevProps.isOpen === nextProps.isOpen,
)

export default Labo
